// extracted by mini-css-extract-plugin
export default {"root":"LearnMoreLink_root__CzYln"};